<tt-doc-articles *ngIf="params.docarticle_keyno === '0'"></tt-doc-articles>
<tt-page *ngIf="params.docarticle_keyno !== '0'">
    <tt-page-heading>{{ docArticle.get?.page_heading }}</tt-page-heading>
    <tt-doc-article #docArticle [params]="params"></tt-doc-article>
</tt-page>
